module.exports = __webpack_public_path__ + "media/images/emotions/sebastiao-anger-7cee20fd456d0ab8ab4e9c3a9c7dc4f8.svg";